import QTabPane from '../tabs/src/tab-pane.vue';



export default QTabPane;
